let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dJuok")).then(() => parcelRequire('jLqzd'));